import SysAppLoggerList from "../component/SysAppLoggerList";
import React from "react";

const SysAppLoggerListContainer = () => (<SysAppLoggerList />)

export default SysAppLoggerListContainer;